function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1224",
  "data-name": "Group 1224",
  transform: "translate(-229.933 -262)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_571",
  "data-name": "Path 571",
  d: "M-14023.354,1337.131s23.459-34.522,51.6,0",
  transform: "translate(14255.354 -1033.665)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_185",
  "data-name": "Ellipse 185",
  transform: "translate(237 262)",
  fill: "#707070",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5.5,
  rx: 5,
  ry: 5.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5.5,
  rx: 4.5,
  ry: 5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_186",
  "data-name": "Ellipse 186",
  transform: "translate(266 262)",
  fill: "#707070",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5.5,
  rx: 5,
  ry: 5.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 5,
  cy: 5.5,
  rx: 4.5,
  ry: 5,
  fill: "none"
})));

var SvgSadSmile = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55.608,
    height: 43.047,
    viewBox: "0 0 55.608 43.047",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSadSmile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sad-smile.d5e5cca5.svg";
export { ForwardRef as ReactComponent };